const VersioningLoader = ({length, version}) => {
    return (
            <div className="loading_versioning_cont">
                {Array.from({ length: length }).map((_, index) => (
                    <div className="loading_versioning_items fade-in" key={index}>{version}</div>
                ))}
            </div>
    )
}

export default VersioningLoader